<template>
  <pt-save-sign-notes-table class="pt-save-sign-table__withData" @getTableData="getTableData" :totalNumber="totalNumber"
  :tableData="tableData" :pageSize="pageSize" ref="table" :isOutside="isOutside" :ruleActivityCode="ruleActivityCode">
  <slot/>
  </pt-save-sign-notes-table>
</template>

<script>
import PtSaveSignNotesTable from './index'
export default {
  name: 'pt-save-sign-notes-table__withData',
  components: {
    'pt-save-sign-notes-table': PtSaveSignNotesTable
  },
  props: {
    paramsData: {
      type: Object
    },
    isFromRouter: {
      type: Boolean
    },
    id: {
      type: String
    },
    ruleActivityCode: {
      type: String,
      default: ''
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (this.isFromRouter) {
        //   this.getTableData(0)
          this.isOutside = true
          this.getTableData(this.page)
        } else {
          this.resetPage()
        }
      },
      deep: true
    }
  },
  data () {
    return {
      totalNumber: null,
      tableData: [],
      pageSize: 10,
      signId: null,
      loading: false,
      isOutside: false
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      let dataNotes = {
        mallRegistrationId: this.id,
        pageableParam: {
          page: page,
          size: this.pageSize
        },
        ...this.paramsData
      }
      this.$store.dispatch('getSignNotes', dataNotes).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$refs.table.showReTry()
        this.$message.error(err || '获取活动报名记录失败')
      })
    }
  }
}
</script>
